import ReactOnRails from 'react-on-rails';

import Header from '../components/Header';
import NextUpImage from '../components/NextUpImage';
import Favorite from '../components/Favorite';
import PhotoDetailImage from '../components/PhotoDetailImage';
import FavoriteToast from '../components/FavoriteToast';
import StickyHead from '../components/StickyHead';
import LinkAgent from '../components/LinkAgent';
import Footer from '../components/Footer';
import SocialSharingWidgets from '../components/SocialSharingWidgets';
import Spinner from '../components/Spinner';
import VendorItem from '../components/VendorItem';
import FavoriteStore from '../components/Favorite/store';

ReactOnRails.register({
  Header,
  StickyHead,
  VendorItem,
  Favorite,
  FavoriteStore,
  SocialSharingWidgets,
  PhotoDetailImage,
  LinkAgent,
  NextUpImage,
  FavoriteToast,
  Footer,
  Spinner,
});
